//数据
export default {

	systemData:{},
	Login:{},
	Query:{},
	Search:{},
	Router:[],
	platformType: 'portal', // 平台类型: report=数据报告类, portal=门户网站类
	platformTypeLoaded: false, // 是否已从API加载platformType
	Icon:{
	  productList: {
		now: "#icon-nav_yingxiao_pre",
		active: "#icon-nav_yingxiao_pre",
		inactive: "#icon-nav_yingxiao_normal",
	  },
	  queryCenter: {
		now: "#icon-nav_chazhao_normal",
		active: "#icon-nav_chazhao_pre",
		inactive: "#icon-nav_chazhao_normal",
	  },
	  userCenter: {
		now: "#icon-nav_info_normal",
		active: "#icon-nav_info_pre",
		inactive: "#icon-nav_info_normal",
	  }
	},

	LoanInfos : [],
	ShowLoanInfo : false,
	CompanyName : "",


}


// WEBPACK FOOTER //
// ./src/store/state.js